<template>
  <div>
      PERMISSION DENIED PLACEHOLDER CONTENT
  </div>
</template>

<script>
export default {
    name: "permissionDenied"
}
</script>

<style>

</style>